import { zodResolver } from '@hookform/resolvers/zod'
import { Flex, Text } from '@workwhile/ui'
import { TipAmountInput } from 'components/SendTipModal/components/TipAmountInput'
import { formatCurrency } from 'lib/string'
import { FormProvider, useForm, useWatch } from 'react-hook-form'
import { BulkTipVariant } from '../constants'
import { amountSchema } from '../schema'
import { useTipHistory } from 'queries/worker'

type BulkTipModalVariantTipEachProps = {
  shiftId: number
  onSubmit: (data: { tips: { workId: number; amount: number }[] }) => void
}

export const BulkTipModalVariantTipEach = ({
  shiftId,
  onSubmit,
}: BulkTipModalVariantTipEachProps) => {
  const form = useForm({
    defaultValues: {
      amount: null,
    },
    resolver: zodResolver(amountSchema),
  })
  const amount = useWatch({ control: form.control, name: 'amount' })

  const { data: works = [] } = useTipHistory(
    { shiftId },
    {
      enabled: Boolean(shiftId),
      select: (data) =>
        data.workHistory.map((item) => ({
          workId: item.work.workId,
        })),
    }
  )

  const handleSubmit = ({ amount }) => {
    onSubmit({
      tips: works
        .map((item) => ({
          workId: item.workId,
          amount,
        }))
        .filter((item) => item.amount > 0),
    })
  }

  const totalAmount = (Number(amount) || 0) * works.length

  return (
    <FormProvider {...form}>
      <form
        id={BulkTipVariant.TipEach}
        onSubmit={form.handleSubmit(handleSubmit)}
      >
        <Flex flexDirection="column" gap={4}>
          <Text>Each worker will receive the full amount you enter.</Text>
          <TipAmountInput title="Individual Amount" />
          <Flex gap={2} justifyContent="flex-end">
            <Text>{`Total amount (${works.length} worker${
              works.length > 1 ? 's' : ''
            }):`}</Text>
            <Text as="span" fontWeight="bold">
              {formatCurrency(totalAmount)}
            </Text>
          </Flex>
        </Flex>
      </form>
    </FormProvider>
  )
}
